import { Typography } from "@mui/material";
import packageJson from "../../package.json";
import { useTranslation } from "react-i18next";

export default function AppVersion() {
  const { t } = useTranslation();

  return (
    <Typography alignSelf={"flex-end"} fontSize={12} color="gray">
      {t("version")}: {packageJson.version}
    </Typography>
  );
}
